import { Variant } from '@material-ui/core/styles/createTypography'

const props = {
  MuiButtonBase: {
    disableRipple: true,
  },
  MuiCardHeader: {
    titleTypographyProps: { variant: 'h6' as Variant },
  },
}

export default props
